import { FlowObsoleteBlockType } from 'flow-schema';

import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import { BlockType, SpecialBlockType, UnknownBlockType } from '../base/baseSchema.js';

/**
 * Transcribed from https://notable-health.atlassian.net/wiki/spaces/notableengineering/pages/3667722258/Skill-ready+blocks
 * as of 2025-12-10
 */
export const SKILL_V2_BLOCK_TYPE_COMPATIBILITY: FlowDefinitionBlockCompatibilityByBlockType = {
  [BlockType.Start]: FlowDefinitionBlockTypeCompatibility.Required,
  [BlockType.Output]: FlowDefinitionBlockTypeCompatibility.Required,
  [BlockType.SubFlowV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.IteratorV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Repeat]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Conditional]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Switch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ScriptedFlow]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Text]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FilterList]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.UpdateFlowConfig]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.LlmPrompt]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Evaluation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.MedicalNecessityCheck]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Fhir]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.OcrV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.InformationExtraction]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.VoiceCallV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.VoiceTranscribe]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.HieQueryDocuments]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.HieGetDocuments]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.WaitForFormCompletion]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Conversation]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.AdvancedFhir]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.HCCAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.DocumentTemplate]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GenerateFile]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.PatientDataStore]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Rest]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.Form]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.FormV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetFormSet]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetInsurances]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.SendEmail]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.SendSms]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Fax]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.HumanTask]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.UpdateNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Hl7]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Mirth]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.MontageOnBase]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.RealTimeEligibility]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.InsuranceCard]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FileConversion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitForSignal]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Callback]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.CareGapAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.DocumentExtract]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetPatient]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetPatientOrder]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetProvider]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.ExportExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.ExportTextToBucket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.CreateEncounterSummary]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.CreatePatientOrder]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.AsynchronousExportJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.CreateNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.DocumentSearch]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.GetSftpFile]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.ServiceReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [SpecialBlockType.SkillV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  // Retired blocks
  [BlockType.AuthorizationSubmission]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Wait]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.IteratorV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.SubFlowV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.VoiceCall]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Ocr]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.RestApiClassicAuthorization]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Scheduling]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.AsynchronousExtractJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // Obsolete blocks
  [FlowObsoleteBlockType.ObsoleteApiSubmissions]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteGetEncounterSummary]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteHumanReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSkill]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSendToLabelboxForReview]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteWaitForAvailableSchedulingSlot]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [UnknownBlockType.Unknown]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
};
